import React, { useContext } from 'react';
import CustomizePageContext from '../CustomizeContext/CustomizePageContext';
import CustomizeSection from '../CustomizePageSection';
import { MULTI_LANG_CONTENT_TYPES } from '../Constants/values';
import CustomizeComponentFactory from '../CustomizeComponentFactory';

const MultiLangSection = ({ ecmContent, contentType, forwardProps = {} }) => {
  const { selectedLanguage } = useContext(CustomizePageContext);
  const { languageContainer } = ecmContent;

  const activeLanguageContainer = languageContainer.find((cur) => {
    return selectedLanguage[cur.domain] === cur.languageKey;
  });

  if (!activeLanguageContainer) {
    return null;
  }

  const languageContainerContent = activeLanguageContainer.content;
  const content = languageContainerContent.content;

  if (contentType === MULTI_LANG_CONTENT_TYPES.step) {
    return <CustomizeSection {...forwardProps} ecmContent={content} />;
  }

  if (contentType === MULTI_LANG_CONTENT_TYPES.content) {
    return <CustomizeComponentFactory ecmContent={content} />;
  }

  return null;
};

export default MultiLangSection;
